import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { FeatureFlagsDto } from '../../commonTypes/organization.types';

export interface FeatureFlagsState {
    flags: FeatureFlagsDto[];
    isReady: boolean;
}

const initialState: FeatureFlagsState = {
    flags: [],
    isReady: false,
};

export const featureFlagsSlice = createSlice({
    name: 'featureFlags',
    initialState,
    reducers: {
        setFeatureFlags: (state, action: PayloadAction<FeatureFlagsDto[]>) => {
            state.flags = action.payload;
        },
        setFeatureFlagsReady: (state, action: PayloadAction<boolean>) => {
            state.isReady = action.payload;
        },
        resetFeatureFlags: () => initialState,
    },
});

export const selectFeatureFlags = (state: RootState) => state.featureFlags.flags;
export const selectFeatureFlagsReady = (state: RootState) => state.featureFlags.isReady;

export const { setFeatureFlags, setFeatureFlagsReady, resetFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
